import { Page } from 'modules/design-system';
import styled from 'styled-components';

export namespace AuthLayoutCSS {
  export const Wrapper = styled(Page)`
    align-items: center;
    background-color: ${({ theme }) => theme.colors.surface.contrasting};
    justify-content: center;
    min-height: 100%;
    position: relative;
  `;

  export const LogoBar = styled.div`
    left: 0;
    padding: ${({ theme }) => theme.spacing.m};
    position: absolute;
    top: 0;
    width: 100%;
  `;

  export const CardWrapper = styled.div`
    max-width: 400px;
    padding: ${({ theme }) => theme.spacing.xl};
    width: calc(100% - ${({ theme }) => theme.spacing.xxl});
  `;
}
